<template>
  <div>
    <h2 v-if="!showFormButtons" class="mb-5">
      {{ $route.meta.title }}
    </h2>
    <v-form ref="form" lazy-validation @submit.prevent="submit">
      <global-settings-form
        v-if="settings"
        v-model="settings"
        :errors="formErrors"
        :categories="categories"
        :packaging-selection-rules="packagingSelectionRules"
        :quantity-types="quantityTypes"
        @clear-error="formErrors[$event] = null"
      />
      <v-btn
        v-if="!showFormButtons"
        color="success"
        class="mr-4"
        type="submit"
        :loading="loading"
      >
        <v-icon class="mr-2"> mdi-content-save </v-icon>
        Save
      </v-btn>
      <v-btn v-if="!showFormButtons" text :disabled="loading" @click="back">
        Cancel
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { showModuleDialog, showSnackbar } from '@/actions'
import api from '@/api'
import GlobalSettingsForm from '@/components/form/GlobalSettingsForm.vue'
import packagingSelectionRules from '@/constants/orderSelectionRules'
import { QUANTITY_TYPES } from '@/constants/quantity'
import { translate_messages } from '@/filter'
import { useUserStore } from '@/stores/UserStore'
import { MODULES } from '@/constants/modules'

export default {
  name: 'GlobalSettings',
  components: { GlobalSettingsForm },
  props: ['showFormButtons'],

  data() {
    const settings = this.userStore.settings
    const categories = []
    if (settings?.default_product_category) {
      categories.push(settings.default_product_category)
    }
    const environment = this.userStore.environment ?? {}

    return {
      loading: false,
      valuationPermission: false,
      title: 'Global settings',
      formErrors: {},
      categories,
      boxSettings: [],
      settings: {
        default_load: null,
        default_product_category_id: null,
        default_box_id: null,
        default_pallet_id: null,
        default_container_id: null,
        default_quantity_type: null,
        weight_unit: environment.weight_unit,
        size_unit: environment.size_unit,
        load_in_layers: false,
        min_util_for_layers: null,
        environment_name: environment.name,
        ...(settings ?? {}),
      },
      boxSettingsSearch: '',
      boxSettingsTimeout: null,
    }
  },
  computed: {
    packagingSelectionRules,

    MODULES() {
      return MODULES
    },

    quantityTypes() {
      return QUANTITY_TYPES
    },
  },

  setup() {
    return { userStore: useUserStore() }
  },

  watch: {
    boxSettingsSearch(name) {
      clearTimeout(this.boxSettingsTimeout)
      this.boxSettingsTimeout = setTimeout(() => {
        this.getBoxSettings(name)
      }, 250)
    },
  },

  created() {
    this.getCategories()
    this.getBoxSettings(null)
  },

  methods: {
    showModuleDialog,
    back() {
      this.$router.back()
    },

    async getBoxSettings(name) {
      const data = await this.getSettings(name, 'box')
      this.boxSettings = data.data
    },

    async getSettings(name, scope) {
      const response = await api.get(`load_setting`, {
        params: {
          name,
          scope,
        },
      })

      return response.data
    },

    getCategories() {
      api.get(`/product-category`).then((response) => {
        this.categories = response.data.data
      })
    },

    async updateSettings() {
      const response = await api.put(`/settings`, {
        ...this.settings,
      })

      this.userStore.loginAsEnvironment({
        ...this.userStore.environment,
        name: this.settings.environment_name,
        weight_unit: this.settings.weight_unit,
        size_unit: this.settings.size_unit,
        settings_array: response.data,
      })
    },

    async submit() {
      this.loading = true

      try {
        await this.updateSettings()
        showSnackbar('Settings updated!')
      } catch (error) {
        this.formErrors = translate_messages(error.response.data.errors)
        showSnackbar(
          'Settings could not be updated',
          'Please check the form for errors.',
          'error'
        )
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
}
</style>
